import { instBundle } from '@/axios.js';

const axiosAdmin2 = instBundle.axiosAdmin2;
const axiosSupport = instBundle.axiosSupport;
const axiosNoah = instBundle.axiosNoah;

const getItem = (list, key, value) =>
	list ? list.find(item => item[key] === value) : null;

export default {
	state: {
		departmentList: null,
		positionList: null,
		skinTypeList: [
			{ id: 8, name: '건성' },
			{ id: 9, name: '지성' },
			{ id: 10, name: '중성' },
			{ id: 11, name: '복합성' },
			{ id: 12, name: '민감성' },
		],
		genderList: [
			{ id: 6, name: '남' },
			{ id: 7, name: '여' },
		],
		agesList: [
			{ id: 10, name: '10대' },
			{ id: 20, name: '20대' },
			{ id: 30, name: '30대' },
			{ id: 40, name: '40대' },
			{ id: 50, name: '50대 이상' },
		],
		ratingList: [
			{ id: 1, name: '1' },
			{ id: 2, name: '2' },
			{ id: 3, name: '3' },
			{ id: 4, name: '4' },
			{ id: 5, name: '5' },
		],
		isEvaluationList: [
			{ id: 0, name: '일반' },
			{ id: 1, name: '평가단' },
		],
		gradeList: [
			{ id: 0, name: '그린', color: 'green' },
			{ id: -1, name: '옐로우', color: 'orange' },
			{ id: -2, name: '레드', color: 'red' },
			{ id: -3, name: '블랙', color: 'black' },
		],
		isCertification: [
			{ id: null, value: '전체' },
			{ id: 'false', value: '미인증' },
			{ id: 'true', value: '인증' },
		],
		isConfirmList: [
			{ id: '0', name: '수정대기' },
			{ id: '1', name: '완료' },
			{ id: '2', name: '보류' },
			{ id: '3', name: '반려' },
		],
		adminLevelList: [
			{ id: 1, name: '슈퍼관리자' },
			{ id: 2, name: '일반관리자' },
			{ id: 3, name: '번역관리자' },
			{ id: 4, name: '임시관리자' },
		],
		boardTypeList: [
			{ id: '01', name: '글로우픽 서비스' },
			{ id: '03', name: '글로우픽 스토어' },
		],
		viewTypeList: null,
		faqCategoryList: null,
		newLinkTypeList: null,
		staticCodes: null,
		reviewCommentStateList: [
			// 리뷰신고 리뷰상태
			{ id: 'N', name: '정상' },
			{ id: 'B', name: '블라인드' },
			{ id: 'C', name: '검수중' },
		],
		reportReviewStateList: [
			// 리뷰신고 처리상태
			{ id: 'W', name: '대기' },
			{ id: 'F', name: '완료' },
			{ id: 'H', name: '보류' },
		],
		birthYearList: [...new Array(101).keys()].map(age => ({
			id: age + 1,
			name: `${age + 1}세`,
		})),
		regionList: [],
		eventTypeList: [
			{ id: 1, name: '글픽존' },
			{ id: 2, name: '평가단' },
			{ id: 3, name: '스토어' },
			{ id: 4, name: '샘플링' },
			{ id: 5, name: '설문단' },
			{ id: 6, name: 'SNS' },
		],
		prerequisiteTypeList: [
			{ id: 1, name: '리뷰' },
			{ id: 2, name: '구매' },
			{ id: 3, name: '댓글' },
			{ id: 4, name: '모두 참여 가능' },
			{ id: 5, name: '참여형 아님' },
			{ id: 6, name: '리뷰어 등급' },
			{ id: 7, name: '가입 기간' },
			{ id: 8, name: '픽플' },
		],
		keywords: [],
		firstCategories: [],
		secondCategories: [],
		thirdCategories: [],
		reviewer_grade_list: [
			{ value: 'master', label: 'Lv5 마스터' },
			{ value: 'expert', label: 'Lv4 엑스퍼트' },
			{ value: 'collector', label: 'Lv3 콜렉터' },
			{ value: 'explorer', label: 'Lv2 익스플로러' },
			{ value: 'beginner', label: 'Lv1 비기너' },
		],
		blindList: [
			{ id: 0, name: '블라인드 아님' },
			{ id: 1, name: '수동 블라인드' },
			{ id: 2, name: '자동 블라인드' },
		],
		castCateList: [],
		castAdminList: [],
		instaCateList: [
			{ id: 'default', txt: '기본' },
			{ id: 'multi', txt: '멀티' },
			{ id: 'supporters', txt: '서포터즈' },
			{ id: 'skincare', txt: '스킨케어' },
			{ id: 'tint', txt: '색조' },
			{ id: 'life', txt: '라이프' },
			{ id: 'baby', txt: '베이비' },
			{ id: 'black', txt: '블랙' },
		],
		awardsList: [],
	},
	getters: {
		getItemById: state => (key, id) =>
			getItem(state[`${key}List`], 'id', id),
		getItemByName: state => (key, name) =>
			getItem(state[`${key}List`], 'name', name),
		getListAddNull: state => (key, id, name, option) => {
			if (!name) {
				if (key === 'linkType' || key === 'newLinkType') {
					name = '- 링크 종류 -';
				} else {
					name = '전체';
				}
			}
			const list = state[`${key}List`];
			let parsedList;
			if (option && option.includeList) {
				parsedList = list.filter(linkType => {
					return option.includeList.some(id => id === linkType.id);
				});
			} else if (option && option.exceptList) {
				parsedList = list.filter(linkType => {
					return option.exceptList.some(id => id !== linkType.id);
				});
			} else {
				parsedList = list;
			}
			return parsedList.reduce(
				(acc, curr) => {
					acc.push(curr);
					return acc;
				},
				[{ id: id || id === 0 ? id : null, name }]
			);
		},
		getLimitList:
			() =>
			(maxLimit = 50) => {
				const limitList = [];
				for (let limit = 10; limit <= maxLimit; limit += 10) {
					limitList.push({ id: limit, name: `${limit}개씩` });
				}
				return limitList;
			},
		csStaticCodeList(state) {
			const list = state.staticCodes;
			if (!list) {
				return [];
			}
			const newList = [
				...list
					.filter(item => item.parent_code === 'CS_01')
					.map(item => ({
						code: item.code,
						name: `이벤트 > ${item.name}`,
					})),
				...list.filter(
					item => item.parent_code === 'CS' && item.code !== 'CS_01'
				),
			];
			const targetIdx = newList.findIndex(
				item => item.code === 'CS_01_02'
			);
			const [targetObj] = newList.splice(targetIdx, 1);
			newList.unshift(targetObj);
			return newList;
		},
		keywords(state) {
			return state.keywords.map(item => ({
				id: item.idKeyword,
				name: item.keywordText,
			}));
		},
		categoryName: state => (depth, id) => {
			const key = depth.toLowerCase();
			const targetObj = state[`${key}Categories`].find(
				item => item[`id${depth}Category`] === id
			);
			return targetObj ? targetObj[`${key}CategoryText`] : null;
		},
		getThirdCategory: state => {
			if (state.thirdCategories) {
				return state.thirdCategories.map(item => ({
					id: item.idThirdCategory,
					name: item.thirdCategoryText,
				}));
			}
		},
	},
	mutations: {
		setList(
			state,
			{ list, type, idKey = 'idCommon', nameKey = 'commonText' }
		) {
			state[type] = list.map(item => ({
				id: item[idKey],
				name: item[nameKey],
			}));
		},
	},
	actions: {
		async department({ commit }) {
			const { data } = await axiosAdmin2.get('/api/common/501/codes');
			commit('setList', {
				list: data.data,
				type: 'departmentList',
			});
		},
		async position({ commit }) {
			const { data } = await axiosAdmin2.get('/api/common/551/codes');
			commit('setList', {
				list: data.data,
				type: 'positionList',
			});
		},
		async viewType({ commit }) {
			const { data } = await axiosAdmin2.get('/api/common/2100/codes');
			commit('setList', {
				list: data.data,
				type: 'viewTypeList',
			});
		},
		async faqCategory({ commit }) {
			const { data } = await axiosAdmin2.get('/v3/api/faq/category');
			commit('setList', {
				list: data,
				type: 'faqCategoryList',
				idKey: 'code',
				nameKey: 'name',
			});
		},
		async newFilters({ state }) {
			const { data } = await axiosSupport.get('/app');
			state.newLinkTypeList = Object.keys(data.link_type).map(id => ({
				id,
				name: data.link_type[id],
			}));
			state.staticCodes = data.static_codes;
		},
		async region({ commit }) {
			const { data } = await axiosAdmin2.get('/api/common/4/codes');
			commit('setList', {
				list: data.data,
				type: 'regionList',
			});
		},
		async app({ state }) {
			const { data } = await axiosSupport.get('/admin/app');
			state.keywords = data.keywords;
			state.firstCategories = data.firstcategories;
			state.secondCategories = data.secondcategories;
			state.thirdCategories = data.thirdcategories;
		},
		async castCate({ state }) {
			const {
				data: { pouchCategoryList },
			} = await axiosAdmin2.get('/admin-api/v2/pouch/category/simple');
			state.castCateList = pouchCategoryList.map(item => ({
				id: item.idPouchCategory,
				name: item.pouchCategoryText,
			}));
		},
		async castAdmin({ state }) {
			const {
				data: { registerList },
			} = await axiosNoah.get('/pouch/register/simple');
			state.castAdminList = registerList.map(item => ({
				id: item.idRegister,
				name: item.nickName,
			}));
		},
		async awards({ state }) {
			const { data } = await axiosAdmin2.get('/api/awards');
			state.awardsList = data;
		},
		async initFilter({ dispatch }) {
			await Promise.all([
				dispatch('department'),
				dispatch('position'),
				dispatch('viewType'),
				dispatch('faqCategory'),
				dispatch('newFilters'),
				dispatch('region'),
				dispatch('app'),
				dispatch('castCate'),
				dispatch('castAdmin'),
				dispatch('awards'),
			]);
		},
	},
};
